import React from 'react';
import PropTypes from 'prop-types';

import { Edit03Icon, IconButton } from '@metarouter-private/mr-mui';

import isAllowedToWritePipelineSchemaLibrary from '@ion/api/pipeline-schema-libraries/isAllowedToWritePipelineSchemaLibrary';

export default function EditPipelineSchemaLibraryButton({ onClick }) {
  const hasPermission = isAllowedToWritePipelineSchemaLibrary();

  return (
    <IconButton data-test-id="editPipelineSchemaLibraryButton" disabled={!hasPermission} onClick={onClick}>
      <Edit03Icon />
    </IconButton>
  );
}

EditPipelineSchemaLibraryButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};
